import './wdyr'

import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { CacheProvider } from './helpers/CacheContext'
import { unregister } from './serviceWorker'

const root = createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <CacheProvider>
      <App />
    </CacheProvider>
  </React.StrictMode>
);


unregister()
